var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.content &&
      _vm.content.settings &&
      _vm.content.settings.general &&
      _vm.content.settings.general.title_banner_header
  )?_c('div',{staticClass:"d-flex px-2 align-items-center justify-content-center banner-header mb-3 "},[_c('h4',{staticClass:"m-0"},[_vm._v(" "+_vm._s(_vm.content.settings.general.title_banner_header)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }